export default "__VITE_ASSET__CZxj_GLU__"